import { Route, Routes } from 'react-router-dom';

import { PresetsEditPaymentItems } from './PresetsEditPaymentItems';
import { PresetsEditPayoutItems } from './PresetsEditPayoutItems';

export const PresetsEdit: React.FC = () => (
  <Routes>
    <Route element={<PresetsEditPaymentItems />} path="payment_items" />
    <Route element={<PresetsEditPayoutItems />} path="payout_items" />
  </Routes>
);
